import axios from 'axios';
import Vue from 'vue';
import router from '../../router';

const state = {
    id: null,
    email: null,
    first: null,
    last: null,
    name: null,
    picture_url: null,
    session: null
};

const mutations = {
    logout(state){
        state.id = null;
        state.email = null;
        state.first = null;
        state.last = null;
        state.name = null;
        state.picture_url = null;
        state.session = null;
    },
    data(state, data) {
        Object.assign(state, data);
    },
};

const actions = {
    logout({commit, dispatch}){
        return axios.post('/logout')
        .then(() => commit('logout'))
        .then(() => dispatch('products/clear', null, {root: true}))
        .then(() => dispatch('courses/clear', null, {root: true}));
    },
    load({ commit, dispatch }) {
        return axios.get('/me')
        .then(response => {
            if (response.$error) {
                throw new Error('Error loading account');
            } else {
                commit('data', response.$data)
            }
        })
        .then(() => dispatch('products/load', null, {root: true}))
        .catch(error => {
            if (error?.response?.status !== 200) {
                //This is an invalid token and we should log the user out
                dispatch('logout');
                router.push({ name: 'home' });
            }
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
